/**
 * Hosts de desenvolvimento local.
 *
 * `<slug>.localhost` é o portal white-label de uma revenda em DESENVOLVIMENTO
 * (issue #737): o backend mapeia esse host para a revenda daquele portal quando
 * `DEBUG` está ligado, e é assim que se loga com um cliente cativo sem usar o
 * domínio de produção da revenda.
 *
 * `.localhost` é TLD reservado (RFC 6761) — não é registrável na internet
 * pública, então um host desses nunca é produção. A checagem é por SUFIXO
 * `.localhost`, nunca "contém localhost": `localhost.exemplo.com` é um domínio
 * de terceiro comum e não pode passar por aqui.
 */
export const isLocalhostHostname = (hostname: string): boolean => {
  const host = (hostname || '').toLowerCase()
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    (host.endsWith('.localhost') && host.length > '.localhost'.length)
  )
}
